import ThirdPartyCompanyEditor from '_legacy/modules/shared/columns/editors/ThirdPartyCompanyEditor';
import { CompanyWeightingType } from 'common/types/companyWeightingType';

class ThirdPartyOperatorEditor extends ThirdPartyCompanyEditor {
    render() {
        return super.render(null, CompanyWeightingType.Operator);
    }
}

export default ThirdPartyOperatorEditor;
